export const StatusConstants = {
  STATUS_SUCCESS: "Successful",
  STATUS_INITIATED: "Initiated",
  STATUS_PROCESSING: "Processing",
  STATUS_REVERSED: "Reversed",
  STATUS_FAILED: "Failed",
  STATUS_PENDING: "Pending",
};

export const BASE_API_URL = process.env.REACT_APP_API_URL;

export const PAYAZA_AUTH = process.env.REACT_APP_PAYAZA_AUTH;
export const PAYAZA_URL = process.env.REACT_APP_PAYAZA_URL;
export const X_PUSH_MESSAGE_KEY = process.env.REACT_APP_X_PUSH_MESSAGE_KEY;
export const x_api_key = process.env.REACT_APP_X_API_KEY;
export const SEERBIT_URL = process.env.REACT_APP_SEERBIT_URL;
export const SEERBIT_KEY = process.env.REACT_APP_SEERBIT_KEY;
export const SEERBIT_POCKET = process.env.REACT_APP_SEERBIT_POCKET;
export const SEERBIT_EMAIL = process.env.REACT_APP_SEERBIT_EMAIL;
export const SEERBIT_PASS = process.env.REACT_APP_SEERBIT_PASS;
export const VFD_KEY = process.env.REACT_APP_VFD_KEY;
export const VFD_WALLET_CREDS = process.env.REACT_APP_VFD_WALLET_CREDS;
export const FLW_KEY = process.env.REACT_APP_FLW_KEY;
export const PAYSTACK_SECRET = process.env.REACT_APP_PAYSTACK_SECRET;
